import React from "react";
import PropTypes from "prop-types";
import { PAYMENT_METHODS } from "constants/constants";
import { classNameConditional } from "utils/commonMethods";
import "containers/Checkout/CheckoutPaymentOptions/CheckoutPaymentOptions.css";
import { CardIcon, UpiIcon, WalletIcon } from "constants/icons";

//Renders Payment options available on checkout page.
function CheckoutPaymentOptions({
  componentTexts,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
}) {
  const availablePaymentMethods = [
    {
      label: componentTexts.checkout_payment_options_option_1,
      id: PAYMENT_METHODS.CARD.code,
      Image: CardIcon,
    },
    {
      label: componentTexts.checkout_payment_options_option_2,
      id: PAYMENT_METHODS.UPI.code,
      Image: UpiIcon,
    },
    {
      label: componentTexts.checkout_payment_options_option_3,
      id: PAYMENT_METHODS.WALLET.code,
      Image: WalletIcon,
    },
  ];
  const selectPaymentMethodHandler = function (nextPaymentMethod) {
    return setSelectedPaymentMethod(nextPaymentMethod.id);
  };

  return (
    <div className="checkout-page__payment-options">
      {availablePaymentMethods.map(({ Image, ...paymentMethod }) => (
        <div
          key={paymentMethod.id}
          className={
            "outer-shadow checkout-page__payment-method " +
            classNameConditional(
              selectedPaymentMethod === paymentMethod.id,
              "payment-method--selected"
            )
          }
          onClick={selectPaymentMethodHandler.bind(null, paymentMethod)}
        >
          <i>
            <Image />
          </i>
          <span> {paymentMethod.label}</span>
        </div>
      ))}
    </div>
  );
}

CheckoutPaymentOptions.propTypes = {
  componentTexts: PropTypes.object.isRequired,
  selectedPaymentMethod: PropTypes.string.isRequired,
  setSelectedPaymentMethod: PropTypes.func.isRequired,
};

export default CheckoutPaymentOptions;
